module.exports = __webpack_public_path__ + "static/destaque1-f9c9e62c629a268492b9c09b99ee9153.png";